<app-receipt
  [display_columns]="displayedColumns"
  [staged_receipts]="staged_receipts"
  [sse_name]="'ReturnReceipt'"
  [upload_field_text]="'receipt.uploadMultiReturn' | translate"
  [validation_schema]="validation_s"
  [upload_handler]="client_proc"
  [lookupPermanent]="lookupPermanent_c"
  [wasm_split_pattern]="wasm_split_pattern"
  [callme]="callme_c"
  [get_paginated_data]="get_paginated_data_c"
>
</app-receipt>
